export const getPercentInputValue = (value, price) => {
  const percent = Number(value) / Number(price);
  return Math.round(percent * 100);
};
